<script setup>
import { computed, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';

import MediaGrid from 'dashboard/components-next/media/MediaGrid.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const props = defineProps({
  contactId: { type: [Number, String], required: true },
});

const { t } = useI18n();
const store = useStore();

const attachmentsByContact = useMapGetter('mediaLibrary/getContactAttachments');
const uiFlags = useMapGetter('mediaLibrary/getUIFlags');

const attachments = computed(() =>
  attachmentsByContact.value(props.contactId)
);
const isFetching = computed(() => uiFlags.value.isFetchingContact);
const hasContent = computed(() => attachments.value.length > 0);

const fetchAttachments = () => {
  if (props.contactId) {
    store.dispatch('mediaLibrary/getContactAttachments', {
      contactId: props.contactId,
    });
  }
};

watch(
  () => props.contactId,
  (newId, oldId) => {
    if (newId && newId !== oldId) fetchAttachments();
  }
);

onMounted(fetchAttachments);
</script>

<template>
  <div class="p-2">
    <div v-if="isFetching" class="flex justify-center p-3">
      <Spinner :size="20" />
    </div>
    <p
      v-else-if="!hasContent"
      class="p-3 text-sm text-center text-n-slate-11"
    >
      {{ t('MEDIA_LIBRARY.CONTACT_EMPTY') }}
    </p>
    <MediaGrid v-else :attachments="attachments" />
  </div>
</template>
